import { render } from "./CompressorWidget.vue?vue&type=template&id=52053694"
import script from "./CompressorWidget.vue?vue&type=script&lang=js"
export * from "./CompressorWidget.vue?vue&type=script&lang=js"

import "./CompressorWidget.vue?vue&type=style&index=0&id=52053694&noscoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__